import React, { useState } from 'react';

import { TransportCardWrapper } from './style';
import Badge from '../bages';

const TransportCard = ({
  cardsData,
  activeShipmentIndex,
}) => {

  const [activePlacementIndex, setActivePlacementIndex] = useState(-1);

  return (
    <TransportCardWrapper onClick={() => { }}>
      <div className="shipment-container">
        {cardsData.map((item, index) => (
          <div
            key={item.id}
            className={`shipment-card ${item.status === 'Completed' ? 'completed' : 'pending'} ${activePlacementIndex === index ? 'active' : ''}`}
            onClick={() => (activeShipmentIndex !== -1) && setActivePlacementIndex(index)}
          >
            <div className="shipment-header">
              <span className="shipment-title">{item?.amazon_shipment_confirmation_id || ''}</span>
              <Badge status={item.status} />
            </div>
            <p className="shipment-address">{item.address}</p>
          </div>
        ))}
      </div>
    </TransportCardWrapper>
  );
};

export default TransportCard;
